/* 全局共有数据 */

const monthsArray = ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"];

const localimgs=['https://workfiles.chinahc.wang/local01.jpg','https://workfiles.chinahc.wang/local03.jpg'];

const NationDatas = [{
  "id": 1,
  "nation": "汉族"
},
{
  "id": 2,
  "nation": "蒙古族"
},
{
  "id": 3,
  "nation": "回族"
},
{
  "id": 4,
  "nation": "藏族"
},
{
  "id": 5,
  "nation": "维吾尔族"
},
{
  "id": 6,
  "nation": "苗族"
},
{
  "id": 7,
  "nation": "彝族"
},
{
  "id": 8,
  "nation": "壮族"
},
{
  "id": 9,
  "nation": "布依族"
},
{
  "id": 10,
  "nation": "朝鲜族"
},
{
  "id": 11,
  "nation": "满族"
},
{
  "id": 12,
  "nation": "侗族"
},
{
  "id": 13,
  "nation": "瑶族"
},
{
  "id": 14,
  "nation": "白族"
},
{
  "id": 15,
  "nation": "土家族"
},
{
  "id": 16,
  "nation": "哈尼族"
},
{
  "id": 17,
  "nation": "哈萨克族"
},
{
  "id": 18,
  "nation": "傣族"
},
{
  "id": 19,
  "nation": "黎族"
},
{
  "id": 20,
  "nation": "傈僳族"
},
{
  "id": 21,
  "nation": "佤族"
},
{
  "id": 22,
  "nation": "畲族"
},
{
  "id": 23,
  "nation": "高山族"
},
{
  "id": 24,
  "nation": "拉祜族"
},
{
  "id": 25,
  "nation": "水族"
},
{
  "id": 26,
  "nation": "东乡族"
},
{
  "id": 27,
  "nation": "纳西族"
},
{
  "id": 28,
  "nation": "景颇族"
},
{
  "id": 29,
  "nation": "柯尔克孜族"
},
{
  "id": 30,
  "nation": "土族"
},
{
  "id": 31,
  "nation": "达斡尔族"
},
{
  "id": 32,
  "nation": "仫佬族"
},
{
  "id": 33,
  "nation": "羌族"
},
{
  "id": 34,
  "nation": " 布朗族"
},
{
  "id": 35,
  "nation": " 撒拉族"
},
{
  "id": 36,
  "nation": " 毛难族"
},
{
  "id": 37,
  "nation": " 仡佬族"
},
{
  "id": 38,
  "nation": " 锡伯族"
},
{
  "id": 39,
  "nation": " 阿昌族"
},
{
  "id": 40,
  "nation": " 普米族"
},
{
  "id": 41,
  "nation": " 塔吉克族"
},
{
  "id": 42,
  "nation": " 怒族"
},
{
  "id": 43,
  "nation": " 乌孜别克族"
},
{
  "id": 44,
  "nation": " 俄罗斯族"
},
{
  "id": 45,
  "nation": " 鄂温克族"
},
{
  "id": 46,
  "nation": " 崩龙族"
},
{
  "id": 47,
  "nation": " 保安族"
},
{
  "id": 48,
  "nation": " 裕固族"
},
{
  "id": 49,
  "nation": " 京族"
},
{
  "id": 50,
  "nation": " 塔塔尔族"
},
{
  "id": 51,
  "nation": " 独龙族"
},
{
  "id": 52,
  "nation": " 鄂伦春族"
},
{
  "id": 53,
  "nation": " 赫哲族"
},
{
  "id": 54,
  "nation": " 门巴族"
},
{
  "id": 55,
  "nation": " 珞巴族"
},
{
  "id": 56,
  "nation": " 基诺族"
}
]

const sexDatas = [
  {
    id:1,
    sex:"男"
  },
  {
    id:2,
    sex:"女"
  }
]

const whether = [
  {
    id:1,
    is:"是"
  },
  {
    id:2,
    is:"否"
  }
]

const education = [
    {
      "id": 1,
      "education": "小学"
    },
    {
        "id": 2,
        "education": "初中"
    },
    {
        "id": 3,
        "education": "高中"
    },
    {
        "id": 4,
        "education": "专科"
    },
    {
        "id": 5,
        "education": "本科"
    },
    {
        "id": 6,
        "education": "研究生"
    },
    {
        "id": 7,
        "education": "博士及以上"
    }
]

const weatherdatas = [
  {
    "type": '晴'
  },
  {
    "type": '阴'
  },
  {
    "type": '多云'
  },
  {
    "type": '阵雨'
  },
  {
    "type": '雷阵雨'
  },
  {
    "type": '雨'
  },
  {
    "type": '雪'
  },
  {
    'type': '雾'
  }
]

export default {
  monthsArray,
  NationDatas,
  weatherdatas,
  localimgs,
  education,
  sexDatas,
  whether
}



// WEBPACK FOOTER //
// ./src/assets/js/common/global.js